import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";

import LogoTreeful from "images/custom/logo-HappTreerful.svg";
import LogoJGB from "images/custom/logo-JGBgroup.svg";
import LogoKbro from "images/custom/logo-Kbro.png";
import LogoPetHotel from "images/custom/logo-nordicPetHotel.svg";

const Container = styled.div`
  ${tw`relative -mx-8 px-8`}
`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center mx-auto py-20 md:py-24`}
`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 xl:w-1/5 max-w-xs flex flex-col items-center`}
`;

const Card = styled.div`
  ${tw`flex flex-col items-center sm:items-start h-full mx-4 px-2`}
  .imageContainer {
    img {
      ${tw`h-48 object-contain`}
    }
  }
`;

export default ({ cards = null }) => {
  const defaultCards = [
    {
      imageSrc: LogoJGB
    },
    {
      imageSrc: LogoTreeful
    },
    {
      imageSrc: LogoKbro
    },
    {
      imageSrc: LogoPetHotel
    }
  ];

  if (!cards) cards = defaultCards;

  return (
    <Container>
      <ThreeColumnContainer>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc} alt="" />
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
    </Container>
  );
};
